import { verdictErrorText } from "@/hooks/useDevicePanel";

/** A panel page that could not load, with the backend's reason when it gave one
 * (e.g. "Access denied" for a caller without access or an accepted agreement). */
export function PanelLoadError({ what, error }: { what: string; error: unknown }) {
  return (
    <p role="alert" className="p-6 text-sm text-fg-muted">
      Could not load this {what}
      {error ? `: ${verdictErrorText(error)}` : ""}.
    </p>
  );
}
